import { app } from '../../../../../../app';
import { Controller } from './delete-accounts.controller';

app.component('companyUserDirectoriesManageGroupAccountsDelete', {
    bindings: {
        accounts: '<',
        companyId: '<',
        selectedAccounts: '<',
    },
    controller: Controller,
    templateUrl: require('./delete-accounts.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/delete/delete-accounts.component.js